<template>
    <div class="bg-white rounded">
        <div class="table pt-3 mb-0">
            <div class="add_license d-flex justify-content-between align-items-center flex-wrap mb-3 px-3">
                <h3 class="font-weight-bold f-20 text-left mb-0 text-black">{{ $t('notifications.title') }}</h3>
                <b-button @click="$bvModal.show('notification-modal')"
                    class="export equipment d-flex justify-content-center align-items-center w-fit-content"
                    v-if="allowAddNotifications" variant="primary">
                    <b-icon icon="plus" class="p-0" aria-hidden="true"></b-icon>
                    <p class="mb-0 ml-2 text-white p-0">{{ $t('notifications.addPerson') }}</p>
                </b-button>
            </div>
            <b-table :sticky-header="'calc(100vh - 273px)'" responsive :fields="translatedFields" :items="items" hover
                :per-page="perPage" :current-page="currentPage" show-empty>
                <template #cell(url)="data">
                    <a :href="data.item.url" target="_blank" class="text-primary">
                        {{ data.item.url }}
                    </a>
                </template>
                <template #cell(tags)="data">
                    <div v-if="data.value.length" class="d-flex align-items-center">
                        <div class="table-tags mr-2">{{ data.value[0].add_tag }}</div>
                        <v-app>
                            <v-tooltip bottom v-if="data.value.length > 1">
                                <template #activator="{ on, attrs }">
                                    <div class="table-tags" v-on="on" v-bind="attrs">+{{ data.value.length - 1 }}</div>
                                </template> <span v-html="data.value.slice(1).map(tag => tag.add_tag).join('<br>')"></span>
                            </v-tooltip>
                        </v-app>
                    </div>
                    <p class="mb-0" v-else>-</p>
                </template>
                <template #cell(exclude_tags)="data">
                    <div v-if="data.value.length" class="d-flex align-items-center">
                        <div class="table-tags mr-2">{{ data.value[0].add_tag }}</div>
                        <v-app>
                            <v-tooltip bottom v-if="data.value.length > 1">
                                <template #activator="{ on, attrs }">
                                    <div class="table-tags" v-on="on" v-bind="attrs">+{{ data.value.length - 1 }}</div>
                                </template> <span v-html="data.value.slice(1).map(tag => tag.add_tag).join('<br>')"></span>
                            </v-tooltip>
                        </v-app>
                    </div>
                    <p class="mb-0" v-else>-</p>
                </template>
                <template #cell(action)="data">
                    <div v-if="allowUpdateNotifications || allowDeleteNotifications">
                        <svg @click="editNotificationItem(data.item)" v-if="allowUpdateNotifications"
                            class="mr-4 cursor-pointer" width="18" height="18" viewBox="0 0 18 18" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.52719 16.7477L14.5274 7.74753L10.2525 3.4726L1.25226 12.4728C1.12836 12.5969 1.04034 12.7522 0.997548 12.9222L0 18L5.07684 17.0025C5.2473 16.9598 5.40322 16.8717 5.52719 16.7477V16.7477ZM17.4329 4.84205C17.796 4.47881 18 3.98622 18 3.4726C18 2.95898 17.796 2.46639 17.4329 2.10315L15.8968 0.567123C15.5336 0.203994 15.041 0 14.5274 0C14.0138 0 13.5212 0.203994 13.1579 0.567123L11.6219 2.10315L15.8968 6.37808L17.4329 4.84205Z"
                                fill="#2CCE89" />
                        </svg>
                        <svg @click="showTagDeletePopup(data.item.id)" v-if="allowDeleteNotifications"
                            class="cursor-pointer" width="19" height="20" viewBox="0 0 19 20" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <span v-else> - </span>
                </template>
            </b-table>
            <div class="entries-pagination px-0 px-sm-2">
                <div class="d-flex align-items-center flex-wrap">
                    <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                        <b-form-select v-model="perPage" :options="pageOptions" />
                    </div>
                    <div class="pagination">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                            aria-controls="my-table"></b-pagination>
                    </div>
                    <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">
                        {{ positionText }}
                    </p>
                </div>
            </div>
        </div>
        <b-modal id="notification-modal" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
            :body-class="'equipment-edit-modal'" no-close-on-esc>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ editNotification ? $t('notifications.editPerson') : $t('notifications.addPerson') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="body">
                <b-row>
                    <b-col cols="12" class="mt-3">
                        <b-form-group :label="$t('notifications.nameLabel')" class="text-left mb-3">
                            <b-form-input v-model="form.name"
                                :disabled="!allowAddNotifications && (!editNotification || (editNotification && !allowUpdateNotifications))"
                                :placeholder="$t('notifications.namePlaceholder')" class="unit" required></b-form-input>
                            <p v-if="errors && errors.name" class="field-error mb-lg-3">
                                {{ errors.name[0] }}
                            </p>
                        </b-form-group>
                        <b-form-group :label="$t('notifications.emailLabel')" class="text-left mb-3">
                            <b-form-input v-model="form.email"
                                :disabled="!allowAddNotifications && (!editNotification || (editNotification && !allowUpdateNotifications))"
                                :placeholder="$t('notifications.emailPlaceholder')" class="unit" required></b-form-input>
                            <p v-if="errors && errors.email" class="field-error mb-lg-3">
                                {{ errors.email[0] }}
                            </p>
                        </b-form-group>
                        <b-form-group :label="$t('notifications.addTagsLabel')">
                            <v-select class="f-12" :options="allTags" multiple :reduce="(option) => option.id"
                                v-model="form.tags" />
                            <p v-if="errors && errors.tags" class="field-error">
                                {{ errors.tags[0] }}
                            </p>
                        </b-form-group>
                        <b-form-group :label="$t('notifications.excludeTagsLabel')">
                            <v-select class="f-12" :options="allTags" multiple :reduce="(option) => option.id"
                                v-model="form.exclude_tags" />
                            <p v-if="errors && errors.exclude_tags" class="field-error">
                                {{ errors.exclude_tags[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="align-items-center">
                    <b-col md="6" sm="12" class="mt-3 text-left">
                        <div>
                            <label class="text-left w-fit-content mb-0">{{ $t('notifications.expiryReport') }}</label>
                        </div>
                        <b-form-checkbox v-model="form.expiry_docs_report" name="check-button" switch size="lg"
                            :disabled="!allowAddNotifications && (!editNotification || (editNotification && !allowUpdateNotifications))"
                            class="ml-0-6rem"></b-form-checkbox>
                    </b-col>
                    <b-col md="6" sm="12" class="mt-3">
                        <b-form-group :label="$t('notifications.enterDays')" class="text-left mb-0" v-if="form.expiry_docs_report">
                            <b-form-select v-model="form.expiration_alert_days" class="f-12" :options="[{
                                value: '15',
                                text: '15'
                            }, {
                                value: '30',
                                text: '30'
                            }, {
                                value: '45',
                                text: '45'
                            }, {
                                value: '60',
                                text: '60'
                            }]" />
                            <p v-if="errors && errors.expiration_alert_days" class="field-error mb-lg-3">
                                {{ errors.expiration_alert_days[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" sm="12" class="mt-3 text-left">
                        <div>
                            <label class="text-left w-fit-content mb-0">{{ $t('notifications.requiredReport') }}</label>
                        </div>
                        <b-form-checkbox v-model="form.required_docs_report"
                            :disabled="!allowAddNotifications && (!editNotification || (editNotification && !allowUpdateNotifications))"
                            name="check-button" switch size="lg" class="ml-0-6rem"></b-form-checkbox>
                    </b-col>
                </b-row>
            </div>
            <template #modal-footer>
                <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 mx-0">
                    <b-button class="mx-0 h-40px w-100px m-0"
                        :class="(allowAddNotifications && !editNotification) || (editNotification && allowUpdateNotifications) ? 'mr-3' : ''"
                        @click="resetForm()" variant="secondary">{{ $t('notifications.cancel') }}</b-button>
                    <div class="d-flex align-items m-0"
                        v-if="(allowAddNotifications && !editNotification) || (editNotification && allowUpdateNotifications)">
                        <b-button class="mx-0 mb-0 h-40px m-0 w-100px" variant="primary"
                            @click="updateNotification()">{{ $t('notifications.save') }}</b-button>
                    </div>
                </div>
            </template>
        </b-modal>
        <DeleteModal v-if="showDeletePopup" @confirm="deleteItem($event)" />
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import DeleteModal from "@/components/DeleteModal.vue";
import { checkEmail } from "../../services/helper";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
    name: "NotificationsSection",
    components: { DeleteModal, vSelect },
    data() {
        return {
            items: [],
            checkEmail,
            editNotification: false,
            perPage: 50,
            currentPage: 1,
            notificationID: null,
            emptyTable: false,
            showDeletePopup: false,
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
            form: {
                name: "",
                email: "",
                required_docs_report: false,
                expiry_docs_report: false,
                expiration_alert_days: "30",
                tags: [],
                exclude_tags: []
            },
            errors: {},
        }
    },
    computed: {
        ...mapGetters(["userCompany", 'rolePermissions', 'tags']),
        translatedFields() {
            return [
                { key: "name", label: this.$t('notifications.nameColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "email", label: this.$t('notifications.emailColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "report", label: this.$t('notifications.reportColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "tags", label: this.$t('notifications.tagsColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "exclude_tags", label: this.$t('notifications.excludeTagsColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "Action", sortable: true, thClass: 'font-table-weight-bold' },
            ];
        },
        allowViewNotifications() {
            return this.rolePermissions && this.rolePermissions['Company Settings / Integrations'][0].allow
        },
        allowAddNotifications() {
            return this.rolePermissions && this.rolePermissions['Company Settings / Integrations'][0].allow
        },
        allowUpdateNotifications() {
            return this.rolePermissions && this.rolePermissions['Company Settings / Integrations'][0].allow
        },
        allowDeleteNotifications() {
            return this.rolePermissions && this.rolePermissions['Company Settings / Integrations'][0].allow
        },
        rows() {
            return this.items.length;
        },
        positionText() {
            const endIndex = this.currentPage * this.perPage;
            const startIndex = this.rows > 0 ? (this.currentPage - 1) * this.perPage + 1 : 0;
            const end = endIndex > this.rows ? this.rows : endIndex;
            return this.$t('notifications.positionText', { start: startIndex, end, total: this.rows });
        },
        allTags() {
            return this.tags.map((item) => {
                return {
                    id: item.id,
                    label: item.add_tag,
                }
            })
        }
    },
    methods: {
        ...mapActions(['getAllNotifications', "deleteCompanyNotification", "setNotification", "updateCompanyNotification", "addCompanyNotification", "setLoader"]),
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (value === "") {
                    nullKeys.push(key);
                }
                else if (key === 'email' && !this.checkEmail(value)) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async deleteItem(status) {
            if (status) {
                try {
                    await this.deleteCompanyNotification(`${this.notificationID}/?company_id=${this.userCompany}`)
                    await this.setNotification({
                        msg: this.$t('notifications.notificationDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.notificationID = null
                    this.showDeletePopup = false;
                    await this.getNotifications()
                }
                catch (e) {
                    console.log(e)
                }
            }
            else this.showDeletePopup = false
        },
        showTagDeletePopup(id) {
            this.showDeletePopup = true;
            this.notificationID = id;
        },
        async getNotifications() {
            const data = await this.getAllNotifications(this.userCompany);
            this.items = [];
            data.map((item) => {
                this.items.push({
                    id: item.id,
                    name: item.name,
                    email: item.email,
                    required_docs_report: item.required_docs_report,
                    expiry_docs_report: item.expiry_docs_report,
                    expiration_alert_days: item.expiration_alert_days,
                    report: item.expiry_docs_report || item.required_docs_report ? `${item.expiry_docs_report ? this.$t('notifications.expiry') : ''} ${item.required_docs_report ? (item.expiry_docs_report ? ', ' : '') + this.$t('notifications.required') : ''}` : '-',
                    tags: item.tags ? item.tags : [],
                    exclude_tags: item.exclude_tags ? item.exclude_tags : []

                })
            })
        },
        resetForm() {
            this.$bvModal.hide('notification-modal')
            this.errors = {}
            this.notificationID = null
            this.form = {
                name: "",
                email: "",
                required_docs_report: false,
                expiry_docs_report: false,
                expiration_alert_days: "30",
                tags: [],
                exclude_tags: []
            },
                this.editNotification = false
        },
        async updateNotification() {
            try {
                this.errors = {}
                const nullKeys = this.checkNullValues({
                    name: this.form.name,
                    url: this.form.url,
                    email: this.form.email
                });
                if (nullKeys.length === 0) {
                    let successMsg = this.$t('notifications.notificationAdded')
                    if (this.editNotification) {
                        successMsg = this.$t('notifications.notificationUpdated')
                        try {
                            this.setLoader(true)
                            await this.updateCompanyNotification({
                                id: this.notificationID,
                                payload: { ...this.form, company: this.userCompany }
                            })
                        }
                        catch (e) {
                            this.setLoader(false)
                            await this.setNotification({
                                msg: e,
                                type: "error",
                                color: "red",
                            });
                            return
                        }
                    }
                    else {
                        try {
                            this.setLoader(true)
                            await this.addCompanyNotification({ ...this.form, company: this.userCompany })
                        }
                        catch (e) {
                            this.setLoader(false)
                            await this.setNotification({
                                msg: e,
                                type: "error",
                                color: "red",
                            });
                            return
                        }
                    }
                    await this.setNotification({
                        msg: successMsg,
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false)
                    this.resetForm()
                    this.getNotifications()
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        if (x === 'url' && this.form.url) error[x] = [this.$t('notifications.wrongFormat')];
                        else error[x] = [this.$t('notifications.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
            }
        },
        editNotificationItem(data) {
            this.editNotification = true
            this.form = {
                name: data.name,
                email: data.email,
                required_docs_report: data.required_docs_report,
                expiry_docs_report: data.expiry_docs_report,
                expiration_alert_days: data.expiration_alert_days ? data.expiration_alert_days : "30",
                tags: data.tags ? data.tags.map((tag) => tag.id) : [],
                exclude_tags: data.exclude_tags ? data.exclude_tags.map((tag) => tag.id) : []
            }
            this.notificationID = data.id
            this.$bvModal.show('notification-modal')
        },
    },
    async mounted() {
        this.getNotifications();
    }
}
</script>